'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _MobileAction = require('./MobileAction.scss');

var _MobileAction2 = _interopRequireDefault(_MobileAction);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _payment = require('redux/modules/payment');

var _popup = require('redux/modules/popup');

var _trip = require('redux/modules/trip');

var _customize = require('redux/modules/customize');

var _reactRouterRedux = require('react-router-redux');

var _LoadingButton = require('components/Loader/LoadingButton');

var _LoadingButton2 = _interopRequireDefault(_LoadingButton);

var _payment2 = require('utils/payment');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  MobileAction: {
    displayName: 'MobileAction'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/MobileAction.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Scroll from 'react-scroll';
// const ScrollLink = Scroll.Link;

// import { commaizeInt, getDisplayPrice } from 'utils/helpers';
// import { ceil } from 'utils/price';


var MobileAction = _wrapComponent('MobileAction')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sessionData: state.session.data,
    rates: state.info.exchangeRates,
    omitBookingFee: state.info.userConfig.omitBookingFee,
    isOpenPeerReview: state.trip.isOpenPeerReview,
    requesting: state.payment.requesting,
    siteConfigs: state.info.siteConfigs,
    //
    weChatEveryLink: state.info.siteConfigs.weChatEveryLink
  };
}, {
  setPaymentData: _payment.setPaymentData,
  logCustomizeTrip: _customize.logCustomizeTrip,
  push: _reactRouterRedux.push,
  openPeerReview: _trip.openPeerReview,
  logRequest: _payment.logRequest,
  openWeChatPopup: _popup.openWeChatPopup
}), _dec2 = (0, _reactCssModules2.default)(_MobileAction2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MobileAction, _Component);

  function MobileAction(props) {
    (0, _classCallCheck3.default)(this, MobileAction);

    // this.renderSalePrice = this.renderSalePrice.bind(this);
    var _this = (0, _possibleConstructorReturn3.default)(this, (MobileAction.__proto__ || (0, _getPrototypeOf2.default)(MobileAction)).call(this, props));

    _this.requestForm = _this.requestForm.bind(_this);

    if (!(typeof _this.requestForm === 'function')) {
      throw new TypeError('Value of "this.requestForm" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.requestForm));
    }

    _this.openPeerReview = _this.openPeerReview.bind(_this);

    if (!(typeof _this.openPeerReview === 'function')) {
      throw new TypeError('Value of "this.openPeerReview" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openPeerReview));
    }

    return _this;
  }

  (0, _createClass3.default)(MobileAction, [{
    key: 'getQuantity',
    value: function getQuantity() {
      return this.props.sessionData.quantity > this.props.trip.max_travelers ? this.props.trip.max_travelers : this.props.sessionData.quantity;
    }
  }, {
    key: 'mobileRequest',
    value: function mobileRequest() {
      var requestType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'message';

      var quantity = this.getQuantity();
      var trip = this.props.trip;

      var paymentData = {
        trip: trip,
        quantity: quantity,
        requestType: requestType,
        device: 'mobile'
      };
      this.props.setPaymentData(paymentData);
      this.props.logRequest({
        tripId: trip._id,
        quantity: quantity,
        requestType: requestType,
        device: 'mobile'
      });
      this.props.push((0, _payment2.parseDataToQuery)(paymentData));
    }
  }, {
    key: 'requestForm',
    value: function requestForm() {
      this.props.logCustomizeTrip('mobile', this.props.trip._id);
      this.props.push('/customize/' + this.props.trip.slug);
    }
    // renderSalePrice() {
    //   const {quantity, currency} = this.props.sessionData;
    //   const {trip, omitBookingFee, rates, siteConfigs} = this.props;
    //   if (siteConfigs.fixYuan) {
    //     return (
    //       <span styleName="mobile-request-price"><span styleName="mobile-request-price-yellow">{commaizeInt(ceil(getDisplayPrice(quantity, trip.full_prices, omitBookingFee), 'CNY', rates))} 元</span>/
    //         {
    //           trip.is_per_day === true ? <FormattedMessage id="trip.detail.head.day"/> : <FormattedMessage id="trip.detail.head.person"/>
    //         }
    //       </span>
    //     );
    //   }
    //   return (
    //     <span styleName="mobile-request-price"><span styleName="mobile-request-price-yellow">{commaizeInt(ceil(getDisplayPrice(quantity, trip.full_prices, omitBookingFee), currency, rates))} {currency}</span>/
    //       {
    //         trip.is_per_day === true ? <FormattedMessage id="trip.detail.head.day"/> : <FormattedMessage id="trip.detail.head.person"/>
    //       }
    //     </span>
    //   );
    // }

  }, {
    key: 'openPeerReview',
    value: function openPeerReview() {
      this.props.openPeerReview();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          trip = _props.trip,
          requesting = _props.requesting,
          peerReview = _props.peerReview,
          isOpenPeerReview = _props.isOpenPeerReview,
          siteConfigs = _props.siteConfigs;
      var weChatEveryLink = this.props.weChatEveryLink;

      return _react3.default.createElement(
        'div',
        { styleName: isOpenPeerReview ? 'mobile-request-toggle-hide' : 'mobile-request-toggle-show' },
        function () {
          if (peerReview) {
            return _react3.default.createElement(
              'a',
              { styleName: 'btn-review', onClick: _this2.openPeerReview },
              'Review This Trip'
            );
            // return (
            //   <ScrollLink to="peerReview" smooth offset={-80} duration={500}>
            //     <span styleName="btn-review">Review This Trip</span>
            //   </ScrollLink>
            // );
          } else if (weChatEveryLink) {
            return _react3.default.createElement(
              'a',
              { className: 'wechat-book', styleName: 'btn-request-first-mobile', onClick: function onClick() {
                  return _this2.props.openWeChatPopup();
                } },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
            );
          } else if (trip.is_request_form !== true) {
            return _react3.default.createElement(
              'div',
              { styleName: 'mobile-request-action' },
              siteConfigs.showLineAddAndFacebookMessage && [_react3.default.createElement(
                'a',
                { styleName: 'btn-chat-facebook', target: '_blank', href: 'https://m.me/pachantiew' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_fb_message' })
              ), _react3.default.createElement(
                'a',
                { styleName: 'btn-chat-line', target: '_blank', href: 'https://line.me/R/ti/p/%40rol5201y' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_line_message' })
              )],
              !siteConfigs.showLineAddAndFacebookMessage && (requesting ? _react3.default.createElement(
                'a',
                { styleName: 'btn-chat-mobile-loading' },
                _react3.default.createElement(_LoadingButton2.default, null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
              ) : _react3.default.createElement(
                'a',
                { className: 'trip-message', styleName: 'btn-chat-mobile', onClick: _this2.mobileRequest.bind(_this2, 'message') },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
              )),
              !siteConfigs.showLineAddAndFacebookMessage && (requesting ? _react3.default.createElement(
                'a',
                { styleName: 'btn-request-mobile-loading' },
                _react3.default.createElement(_LoadingButton2.default, null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
              ) : _react3.default.createElement(
                'a',
                { className: 'trip-book', styleName: 'btn-request-mobile', onClick: _this2.mobileRequest.bind(_this2, 'book') },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
              ))
            );
          }
          return _react3.default.createElement(
            'a',
            { className: 'trip-request-book', styleName: 'btn-request-first-mobile', onClick: _this2.requestForm },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.request_form' })
          );
        }()
      );
    }
  }]);
  return MobileAction;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object,
  sessionData: _react2.PropTypes.object,
  omitBookingFee: _react2.PropTypes.bool,
  rates: _react2.PropTypes.object,
  isWishlisted: _react2.PropTypes.object,
  siteConfigs: _react2.PropTypes.object,
  requesting: _react2.PropTypes.bool,
  peerReview: _react2.PropTypes.bool,
  hideMobileAction: _react2.PropTypes.bool,
  isOpenPeerReview: _react2.PropTypes.bool,
  openPeerReview: _react2.PropTypes.func,
  setPaymentData: _react2.PropTypes.func,
  logCustomizeTrip: _react2.PropTypes.func,
  push: _react2.PropTypes.func,
  logRequest: _react2.PropTypes.func,
  //
  weChatEveryLink: _react2.PropTypes.bool,
  openWeChatPopup: _react2.PropTypes.func
}, _temp)) || _class) || _class));

exports.default = MobileAction;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/MobileAction.js
// module id = 1637
// module chunks = 0